import { useState } from "react";
import { MTopBar } from "@/components/mobile/MTopBar";
import { MPage, MTabs } from "@/components/mobile/parts";
import { QueueList } from "@/components/mobile/QueueList";
import { ClosedComandas } from "@/components/mobile/ClosedComandas";
import { useMobile } from "@/context/MobileContext";

export default function MBackup() {
  const { queue } = useMobile();
  const [tab, setTab] = useState(queue.length ? "queue" : "closed");
  return (
    <>
      <MTopBar title="Backup de comandas" />
      <MPage>
        <MTabs value={tab} onChange={setTab} items={[["queue", "No celular", queue.length], ["closed", "Fechadas"]]} testId="m-backup-tabs" />
        {tab === "queue" ? <QueueList /> : <ClosedComandas />}
      </MPage>
    </>
  );
}
